(function () {
    'use strict';

    function formatPriceWithSmallDecimals(element) {
        if (
            element.dataset.formatted === 'true' ||
            element.querySelector('.price__decimals')
        ) {
            return;
        }

        const originalHTML = element.innerHTML;

        const pricePattern = /(\d+)([,.])(\d{2})(?![,.\d])/g;

        let formattedHTML = originalHTML;
        let hasChanges = false;

        formattedHTML = formattedHTML.replace(
            pricePattern,
            (match, integerPart, separator, decimals) => {
                hasChanges = true;
                return `${integerPart}${separator}<span class="price__decimals">${decimals}</span>`;
            }
        );

        if (hasChanges && formattedHTML !== originalHTML) {
            element.innerHTML = formattedHTML;
            element.dataset.formatted = 'true';
        }
    }

    function formatAllPrices() {
        const priceElements = document.querySelectorAll(
            '.price-item:not([data-formatted="true"])'
        );
        priceElements.forEach(formatPriceWithSmallDecimals);

        const unitPriceElements = document.querySelectorAll(
            '.unit-price:not([data-formatted="true"])'
        );
        unitPriceElements.forEach(formatPriceWithSmallDecimals);
    }

    function init() {
        formatAllPrices();

        const observer = new MutationObserver(() => {
            setTimeout(formatAllPrices, 100);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', () => {
        setTimeout(formatAllPrices, 100);
    });

    document.addEventListener('shopify:section:reorder', () => {
        setTimeout(formatAllPrices, 100);
    });
})();
